<script>
    import { nanoid } from 'nanoid';

    import AddressAutoComplete from './AddressAutoComplete.svelte';
    import TextInput from './TextInput.svelte';
    import EmailInput from './EmailInput.svelte';
    import PhoneInput from './PhoneInput.svelte';
    import DatePicker from './DatePicker.svelte';
    import FormRow from './FormRow.svelte';
    import FormColumn from './FormColumn.svelte';
    import YesNoGroup from './YesNoGroup.svelte';
    import YearMonthDaySelect from './YearMonthDaySelect.svelte';
    import AddButton from './buttons/AddButton.svelte';

    import textStore from "../stores/textStore";
    import Select from './Select.svelte';

    import { otherNameOptions } from '../config/index';

    export let isRegistrationUpdate = false;
    export let required = false;
    export let disabled = false;
    export let idPrefix = 'a' + nanoid(0, 3);
    export let firstName;
    export let surname;
    export let dateOfBirth = null;
    export let emailAddress;
    export let phoneNumber;
    export let address = null;
    export let addressLabel = null;
    export let hasOtherNames = null;
    export let otherNamesList = null;
    export let claimantPlaceOfBirth = null;
    export let skyDiscoveryClaimantDob=null;

    export let showDateOfBirth = true;
    export let showOtherNamesList = true;

    let requiredPhone = true;
    let requiredEmail = true;


    if (address == null){
        address = {};
    }

    const addOtherName = () => {
        otherNamesList = [...otherNamesList, {otherFirstName:null, otherName:null}];
    }


    const otherNamesChanged = (e) => {
        console.log("otherNamesChanged", e, e.target.value, otherNamesList);
        if (e.target.value === "Yes"){
            if (!otherNamesList){
                //otherNamesList = [{otherFirstName:null, otherName:null}];
                addOtherName();
            }else if (otherNamesList && otherNamesList.length < 1){
                //otherNamesList = [{otherFirstName:null, otherName:null}];
                addOtherName();
            }
        }else{
            otherNamesList = [];
        }
        console.log("otherNamesList",  otherNamesList, hasOtherNames);
    }

    const deleteOtherName = (index) => {
        if (otherNamesList.length <= 1) return;

        otherNamesList.splice(index, 1);
        otherNamesList = [ ...otherNamesList];
    }

    if (otherNamesList == null){
        otherNamesList = [{otherFirstName:null, otherName:null}];
    }

    $:{
        if (emailAddress){
			requiredPhone = false;
		}else{
            requiredPhone = true;
        }
		if (phoneNumber){
			requiredEmail = false;
		}else{
            requiredEmail = true;
        }
    }
</script>


<FormRow>
    <FormColumn cols="6">
        <TextInput label="Your first name" {required} disabled={disabled || isRegistrationUpdate} bind:value="{firstName}" id="{idPrefix}_firstName" />
    </FormColumn>
    <FormColumn cols="6">
        <TextInput label="Your last name" {required} disabled={disabled || isRegistrationUpdate} bind:value="{surname}" id="{idPrefix}_surname" />
    </FormColumn>
</FormRow>

{#if showOtherNamesList}
    <FormRow>
        <FormColumn cols="6">
            <YesNoGroup
                {required}
                {disabled}
                label="Do you have any other names? (e.g. maiden name)"
                name="{idPrefix}_hasOtherNames"
                bind:value={hasOtherNames}
                on:change={otherNamesChanged}
            >
            </YesNoGroup>
        </FormColumn>
    </FormRow>


    {#if hasOtherNames === "Yes"}

        {#each otherNamesList as otherName, i (otherName)}
            <FormRow>
                <FormColumn cols="6">
                    <TextInput
                        {required}
                        {disabled}
                        id="{idPrefix}_OtherName"
                        label="Name"
                        bind:value={otherNamesList[i].otherFirstName}/>
                </FormColumn>
                <FormColumn cols="5">
                    <Select
                        label='Type'
                        bind:value={otherNamesList[i].otherName}
                        optionList={otherNameOptions}
                        {disabled}
                        {required}/>
                </FormColumn>
                <FormColumn cols="1" class="last mt-0 d-flex align-items-center">
                    {#if otherNamesList.length > 1}
                        <div class="confirmation-hide">
                            <button on:click|preventDefault={() => deleteOtherName(i)} class="delete " title="Delete" aria-label="Delete">
                                    <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    {/if}
                </FormColumn>
            </FormRow>
        {/each}

        <div class="confirmation-hide" style="margin-top: 20px;">
            <AddButton on:add={addOtherName}>Add other name</AddButton>
        </div>
        <FormRow>
            <FormColumn cols="10"/>
            <FormColumn>

            </FormColumn>
        </FormRow>
    {/if}
{/if}


<FormRow>
    <FormColumn cols="6">
        <EmailInput label="Your email address" required={requiredEmail} disabled={disabled || isRegistrationUpdate} bind:value="{emailAddress}" id="{idPrefix}_email" />
    </FormColumn>
    <FormColumn cols="6">
        <PhoneInput label="Your phone number" required={requiredPhone} disabled={disabled || isRegistrationUpdate} bind:value="{phoneNumber}" id="{idPrefix}_phone" />
    </FormColumn>
</FormRow>

{#if showDateOfBirth}
<FormRow class="d-flex align-items-end">    
    <FormColumn cols="6">
        {#if skyDiscoveryClaimantDob == null}
        <YearMonthDaySelect
            id="{idPrefix}_claimant_contact"
            label="Your date of birth"
            startYear={1850}
            endYear={2023}
            requiredYear={true}
            disabled={disabled || isRegistrationUpdate}
            bind:value={dateOfBirth}

        />
        {:else}
        <TextInput
            id="{idPrefix}_claimant_contact"
            label="Your date of birth"
            disabled={disabled || isRegistrationUpdate}
            bind:value={skyDiscoveryClaimantDob}

        />
        {/if}
    </FormColumn>    
    <FormColumn cols="6">
        <TextInput 
            label="Your place of birth" 
            required={false} 
            disabled={disabled || isRegistrationUpdate} 
            bind:value="{claimantPlaceOfBirth}" 
            id="{idPrefix}_placeOfBirth" />
    </FormColumn>
</FormRow>
{/if}

<AddressAutoComplete {idPrefix}
        bind:addressValid={address.addressValid}
        bind:manualEntry={address.manualEntry}
        bind:googlePlaceJson={address.googlePlaceJson}
        bind:formattedAddress={address.formattedAddress}
        bind:premise="{address.premise}"
        bind:subpremise="{address.subpremise}"
        bind:street="{address.street}"
        bind:suburb="{address.suburb}"
        bind:state="{address.state}"
        bind:postcode="{address.postcode}"
        bind:country="{address.country}"
        bind:lat="{address.lat}"
        bind:lng="{address.lng}"
        bind:placeId="{address.placeId}"
        bind:url="{address.googleMapsUrl}"
        disabled={disabled || isRegistrationUpdate}
        label={addressLabel}
        {required}>
</AddressAutoComplete>

<style>
    .delete {
        border: none;
        outline: none;
        background-color: transparent;
        font-size: 1.1rem;
        font-weight: 700;
        color: var(--color-primary);
        margin-top: 10px;
    }
</style>